import { IStyle, makeStyles } from '@fluentui/react-theme-provider';

export const useSectionLoaderStyles = () => {
  const loader: IStyle = {
    placeItems: 'center',
  };
  const container: IStyle = {
    height: '100%',
    minHeight: 100,
    display: 'grid',
  };
  const srOnly: IStyle = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1,
  };

  return makeStyles({
    loader,
    container,
    srOnly,
  })();
};
